export default "__VITE_ASSET__CmNy$93F__"